import React from "react"
import { useAuth } from "../../contexts/Auth/AuthContext"
import { useNavigate } from "react-router-dom"
// no dropdown in mobile parity
import { useTranslation } from "react-i18next"

const Header = () => {
  // Mobile parity header has no dropdown state
  // const [open, setOpen] = useState(false)
  // const ref = useRef(null)

  useAuth()

  const navigate = useNavigate()

  useTranslation()

  // initials not shown in mobile parity header

  // no outside click handling needed

  const goSettings = () => navigate("/settings")

  return (
    <header className="w-full mx-auto mb-0 md:mb-6 px-4 md:px-6 lg:px-6 flex items-center justify-between">
      {/* Left: wordmark like mobile (96x24 logo substitute) */}
      <div className="flex items-center">
        <span className="text-[28px] font-bold tracking-[0.02em] text-dark-default">
          aigree
        </span>
      </div>

      {/* Right: two thick menu bars */}
      <div className="flex items-center gap-4">
        <button
          onClick={goSettings}
          className="flex flex-col gap-1.5"
          aria-label="menu"
        >
          <div className="w-10 h-[6px] rounded-[4px] bg-dark-default" />
          <div className="w-10 h-[6px] rounded-[4px] bg-dark-default" />
        </button>
      </div>
    </header>
  )
}

export default Header
